import React, { useState } from 'react';
import Watermark from '@tv2/lib-offspring/components/watermark/Watermark';
import { isMobile } from '@tv2/lib-offspring/libs/isMobile';
import { Label } from '../../../../Label';
import { Link } from '../../../../Link';
import { Countdown } from '../countdown/Countdown';
import { CardProps } from './ContentCard';

export function ContentCardLandscape({ card, cardSize, actions }: CardProps): React.ReactNode {
  const [showOverlay, setShowOverlay] = useState(false);
  return (
    <div key={card.id}>
      <Link
        destination={card.countdownTo ? null : card.destination}
        action={card.action}
        onAction={actions}
      >
        <div
          onClick={e => {
            if (card.countdownTo && card.countdownTo > 0) {
              e.preventDefault();
            }
            if (isMobile()) {
              setShowOverlay(x => !x);
            }
          }}
          onMouseEnter={e => {
            if (isMobile()) {
              e.preventDefault();
              return;
            }
            setShowOverlay(true);
          }}
          onMouseLeave={e => {
            if (isMobile()) {
              e.preventDefault();
              return;
            }
            setShowOverlay(false);
          }}
          className="relative hover:scale-s 2xl:hover:scale-xs transition-transform mb-1"
          aria-label={card.title ?? ''}
        >
          <div className="relative">
            <img src={card.imageUrl} className="w-full" alt={card.title ?? ''} />
            {card.logoUrl && (
              <Watermark alt={card.title ?? ''} title={card.title ?? ''} src={card.logoUrl} />
            )}
            {card.countdownTo && card.countdownTo > 0 && showOverlay && (
              <div className="absolute right-0 left-0 top-0 bottom-0">
                <Countdown countdownTo={card.countdownTo} type="normal" />
              </div>
            )}
          </div>
          <div className="flex flex-row">
            {card.labels.map(label => (
              <Label key={label.text} label={label} />
            ))}
          </div>
          {card.title ? (
            <div
              className={`${
                cardSize === 'SMALL' || cardSize === 'XSMALL' ? 'text-heading-xs' : 'text-heading-s'
              } mt-2 mb-0 pb-0 line-clamp-2 text-white`}
            >
              {card.title}
            </div>
          ) : null}
          {card.subTitle ? (
            <div className="mt-1 text-marker-xs line-clamp-1 text-midnight-400">
              {card.subTitle}
            </div>
          ) : null}
        </div>
      </Link>
    </div>
  );
}
